const config = {
    SERVER_IP: 'https://api.upgrade-crm.com'
}

export default config;